var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6553_16330)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3.85714,
    fill: "#244264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80029 8.35721L8.40029 11.3572L13.2003 5.35721",
    stroke: "white",
    strokeWidth: 1.88571
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.642857,
    y: 0.642857,
    width: 16.7143,
    height: 16.7143,
    rx: 3.21429,
    stroke: "#244264",
    strokeWidth: 1.28571
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6553_16330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3.85714,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecked);
export default __webpack_public_path__ + "static/media/ic-checked.294d63b445dbe3918f023a12d7e19e48.svg";
export { ForwardRef as ReactComponent };